import React from "react";
import { recyclebin } from "../icons/icon";
import SmartImage from "./SmartImage";

const AppLoader = ({ text = "Loading...", fullScreen = true }) => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3"
      style={
        fullScreen
          ? { position: "fixed", inset: 0, zIndex: 99999, background: "#fff" }
          : { width: "100%", height: "calc(100vh - 80px)", background: "transparent" }
      }
    >
      {/* Logo + Spinner */}
      <div className="relative flex items-center justify-center w-14 h-14">
        {/* Spinning ring */}
        <div
          className="absolute inset-0 rounded-full border-2 border-slate-100 border-t-[#0EBE3C] animate-spin"
          style={{ animationDuration: "0.85s" }}
        />
        {/* Logo — fully rounded */}
        <SmartImage
          src={recyclebin}
          alt="BINS APP"
          className="w-9 h-9 object-contain rounded-full"
        />
      </div>

      {/* Text */}
      <span className="plusJakara_medium text-slate-400 text-xs tracking-wide">
        {text}
      </span>
    </div>
  );
};

export default AppLoader;
